import { Box, Button, styled, Typography } from "@mui/material"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  rowGap: 20,
})

export const CenterContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
  flexGrow: 1,
  justifyContent: "center",
})

export const SourceDescription = styled(Typography)({
  width: 300,
  textAlign: "center",
  marginTop: 30,
})

export const RecipientContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "20px",
})

export const CloseButton = styled(Button)({
  marginTop: 10,
})

export const ButtonTransfer = {
  display: "flex",
  flexDirection: "column",
}
